import { Row } from "PFApp/booking/types";
import React, { RefObject } from "react";

import Bars from "../bars/bars";

interface BasicRowProps {
  rowRef: RefObject<HTMLDivElement>;
  row: Row;
  startDate: string;
  endDate: string;
  onLoadingChange: (loading: boolean) => void;
  draggedBookingId: number | null;
  onBarDragStart: (bookingId: number) => void;
  onBarDragEnd: () => void;
  shouldBarsOverlap: boolean;
  titleDisabled?: boolean;
  offsetTop?: number;
}

export const BasicRow = ({
  rowRef,
  row,
  startDate,
  endDate,
  onLoadingChange,
  draggedBookingId,
  onBarDragStart,
  onBarDragEnd,
  shouldBarsOverlap,
  titleDisabled,
  offsetTop = 0
}: BasicRowProps) => (
  <Bars
    rowRef={rowRef}
    row={row}
    startDate={startDate}
    endDate={endDate}
    onLoadingChange={onLoadingChange}
    draggedBookingId={draggedBookingId}
    onBarDragStart={onBarDragStart}
    onBarDragEnd={onBarDragEnd}
    offsetTop={offsetTop}
    shouldOverlap={shouldBarsOverlap}
    titleDisabled={titleDisabled}
  />
);
